import { HeaderAvatar } from '@planning/pages/TallymanV2/Components'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { Helmet } from 'react-helmet-async'

export const YardClerkHeader: FC = observer(props => {
  const { t } = useTranslate()

  return (
    <>
      <Helmet>
        <title>{t('yardClerk', 'Yard Clerk')}</title>
      </Helmet>
      <Header title={t('yardClerk', 'Yard Clerk')} rightRenderOption={<HeaderAvatar />} />
    </>
  )
})
